import * as queries from './query';

export { queries };
export default { queries };
